export const USER_SETTINGS_KEY = {
  DASHBOARD_LIST: 'dashboardList', // table configuration for dashboard list
  DATA_EXPORT_SETTINGS: 'dataExportSettings', // user preferences for data export format (CSV/Excel)
  DELIVERY_CHANGES: 'deliveryChanges', // table configuration for delivery changes list
  DELIVERY_LIST: 'deliveryList', // table configuration for deliveries list
  INVOICE_DELIVERY_NOTES_LIST: 'invoiceDeliveryNotesList', // table configuration for list of delivery notes for invoice
  INVOICE_LIST: 'invoiceList', // table configuration for invoices list
  PDF_DOWNLOAD_SETTINGS: 'pdfDownloadSettings', // user preferences for PDF download format and attachments
} as const;

export type UserSettingsKey = keyof typeof USER_SETTINGS_KEY;

export type UserSettingsKeyValues =
  (typeof USER_SETTINGS_KEY)[keyof typeof USER_SETTINGS_KEY];
